import "./ConfirmationModal.css";

type ConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
};

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirmar",
  cancelText = "Cancelar"
}: ConfirmationModalProps) => {
  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      <div className="confirmation-modal-backdrop" onClick={onClose}></div>
      <div className="confirmation-modal">
        {title && (
          <div className="confirmation-modal-header">
            <h3 className="confirmation-modal-title">{title}</h3>
          </div>
        )}

        <div className="confirmation-modal-body">
          <p className="confirmation-modal-message">{message}</p>
        </div>

        <div className="confirmation-modal-footer">
          <button className="btn btn-confirmation-cancel" onClick={onClose}>
            {cancelText}
          </button>
          <button
            className="btn btn-confirmation-confirm"
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </>
  );
};
